import { render, staticRenderFns } from "./baiyi_saturn.vue?vue&type=template&id=52a2a058&scoped=true&"
import script from "./baiyi_saturn.vue?vue&type=script&lang=js&"
export * from "./baiyi_saturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2a058",
  null
  
)

export default component.exports